import Colors from '@/utils/Colors'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String
    },
    itemText: {
      type: String,
      required: true
    },
    itemValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    scrollable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedItemLabel (): string {
      return this.selectedItem ? this.selectedItem[this.itemText] : this.placeholder
    },
    labelStyle (): string {
      return this.selectedItem
        ? `color: ${this.$vuetify.theme.dark ? Colors.white : Colors.black}`
        : `color: ${Colors.simpleGrey}`
    },
    itemStyle (): string {
      return this.$vuetify.theme.dark
        ? `background-color: ${Colors.morningCoffee}; border-color: ${Colors.grey}`
        : `background-color: ${Colors.white}; border-color: ${Colors.light4}`
    }
  },
  mounted () {
    this.setValue()
  },
  data () {
    return {
      selectedItem: '',
      open: false,
      uniqueId: Math.random().toString(36).substring(7),
      Colors
    }
  },
  methods: {
    openMenu (): void {
      if (!this.disabled) {
        this.open = !this.open
      }
    },
    getNextItems () {
      const list = document.getElementById(
        `KeybeSelect__list--text-val-${this.uniqueId}`
      )
      const bottomOfWindow =
      list?.offsetHeight + list?.scrollTop >=
      list?.scrollHeight - 1
      if (bottomOfWindow && this.scrollable) {
        this.$emit('getNext')
      }
    },
    selectItem (item: any) {
      this.selectedItem = item
      this.$emit('input', item[this.itemValue])
    },
    setValue () {
      const selectedItem = this.items.find(item => item[this.itemValue] === this.value)
      this.selectedItem = selectedItem
    },
    itemLabel (item: any): string {
      return item[this.itemText]
    }
  },
  watch: {
    value () {
      this.setValue()
    }
  }
}
